/** Each region is its own lobby (hub, accounts, ratings) on its own subdomain: na.sandsworn.gg, eu.sandsworn.gg. */
export const REGIONS = { na: 'North America', eu: 'Europe' } as const;

const [sub, ...domain] = location.hostname.split('.');
/** Null off the regional subdomains (dev, LAN), where there is nowhere to switch to. */
export const region = sub in REGIONS ? sub : null;

export function goToRegion(id: string): void {
  location.assign(`${location.protocol}//${id}.${domain.join('.')}`);
}
